import React from 'react'
import {Trans} from 'react-i18next'

import {BinIcon, TruckDeliveryIcon} from 'components/CustomIcons'
import useCartContext from 'components/Cart/useCartContext'
import priceParser from 'utils/priceParser'
import FormHandler from 'components/Form/FormHandler'
import BInput from 'components/Form/Fields/BInput'
import BInputNumber from 'components/Form/Fields/BInputNumber'
import BButton from 'components/Form/Fields/BButton'
import Counter from 'components/Cart/Counter'
import HiddenField from 'modules/Checkout/HiddenField'
import TotalPrice from 'modules/Checkout/TotalPrice'

let tmpPrice = 42.42
const tmpPoints = 42

const CheckoutItem = ({product: {quantity, price, metaProduct: {product}}, t}) => {
  const {cartDispatch} = useCartContext()

  const cartQuantity = a => {
    cartDispatch({type: 'quantity', payload: {uuid: product.uuid, quantity: a}})
  }

  const cartRemove = e => {
    e.preventDefault()
    cartDispatch({type: 'remove', payload: product.uuid})
  }

  return (
    <div>
      <div title={product.name}>
        <img alt={product.name} src={product.main_image_url}/>
        <div>
          <span>{product.name}</span>
          <span>{t('Category')} <b>Building material placeholder</b></span>
        </div>
      </div>

      <div>
        <div>
          <button onClick={cartRemove}><BinIcon/></button>
        </div>

        <div>
          <Counter amount={quantity} setAmount={cartQuantity}/> <b>{priceParser(price)}</b>
        </div>
      </div>
    </div>
  )
}

const MerchantDetail = ({e, t}) => (
  <div>
    <div className='checkout1-shopHead'>
      <img alt={e.merchant.name} src={e.merchant.logo_url}/>
      <h4>{e.merchant.name}</h4>
    </div>

    <div className='checkout1-shopItems'>
      {e.products.map(product => (
        <CheckoutItem product={product} t={t}/>
      ))}

      <div>
        <div>
          <TruckDeliveryIcon/>
          <div>
            <span>{t('Delivery')}</span>
            <span>3 - 4 days</span>
          </div>
        </div>

        <div>
          <div><b>{priceParser(tmpPrice)}</b></div>
        </div>
      </div>
    </div>
  </div>
)

const Merchants = ({t, cart}) => {
  const merchants = {}
  Object.keys(cart.items).forEach(e => {
    const merchant = cart.items[e].metaProduct.product.merchant.uuid
    merchants[merchant] = merchants[merchant] ? (
      merchants[merchant].products.push(cart.items[e])
    ) : (
      {
        merchant: {...cart.items[e].metaProduct.product.merchant},
        products: [cart.items[e]],
      }
    )
  })

  return (
    Object.keys(merchants).map(e => (
      <MerchantDetail e={merchants[e]} t={t}/>
    ))
  )
}

const BuildiroTip = ({t}) => (
  <div className='notice checkout-buildiroTip'>
    <div>
      <h6>{t('Buildiro Recommends: Save money on delivery')}</h6>

      <p>
        <Trans i18nKey='checkout-buildiroTip'>
          <b/>
          {{price: priceParser(tmpPrice)}}
        </Trans>
      </p>

      <ul>
        <li>
          <Trans i18nKey='checkout-buildiroTipItem'>
            <b/>
            {{price: priceParser(tmpPrice)}}
            {{product: 'Hamilton Perfection Roller'}}
            {{store: 'Travis Perkins'}}
          </Trans>
        </li>
      </ul>
    </div>
    <div>
      <BButton green>{t('REVIEW OPTIONS')}</BButton>
    </div>
  </div>
)


const Checkout1 = ({t, next, cart, cartDispatch, user, history}) => (
  <div id='checkout1' className='checkout-basicLayout'>
    <h1>{t('Order summary')}</h1>

    <div>
      {/*<BuildiroTip t={t}/>*/}

      <div className='checkout1-shops'>
        <Merchants t={t} cart={cart}/>
      </div>

      <div className='checkout1-total'>
        <TotalPrice t={t}/>

        <div className='checkout1-totalDiscounts'>
          <div className='checkout1-totalDiscountsCode'>
            <HiddenField Title={t('Do you have voucher?')} defaultState={!!cart.discounts[0]}>
              <FormHandler
                initialValues={{voucher: cart.discounts[0]}}
                submitCallback={({voucher}, setLoading) => {
                  cartDispatch({type: 'setVoucher', payload: voucher})
                  setLoading(false)
                }}
                submitTitle={t('APPLY')}
                buttonBordered
              >
                <BInput fieldName='voucher' placeholder={t('Code')}/>
              </FormHandler>
            </HiddenField>
          </div>

          <div className='checkout1-totalDiscountsPoints'>
            <HiddenField
              Title={<>{t('You have')} <b>{tmpPoints} {t('Buildiro points')}</b>. {t('Do you want to apply them?')}</>}
              defaultState={!!cart.points}
            >
              <FormHandler
                initialValues={{points: cart.points}}
                submitCallback={({points}, setLoading) => {
                  cartDispatch({type: 'usePoints', payload: points})
                  setLoading(false)
                }}
                submitTitle={t('APPLY POINTS')}
                buttonBordered
              >
                <BInputNumber
                  fieldName='points'
                  placeholder={t('Points')}
                  max={tmpPoints}
                  min={0}
                  step={1}
                />
              </FormHandler>
            </HiddenField>
          </div>
        </div>
      </div>

      <BButton ghost onClick={_ => history.goBack()}>{t('back to shopping')}</BButton>
      <BButton yellow onClick={next}>{t('continue to')} <b>{t('delivery & billing info')}</b></BButton>
    </div>
  </div>
)

export default Checkout1
